import React, { useEffect, useState } from "react";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { ThemeProvider } from "@material-ui/core/styles";
import { globalTheme } from "style/globalTheme";
import { Grid } from "@material-ui/core";
import { config } from "utilities/config";
import {
  getFormschemapayload,
  createFormsubmitpayload,
  getFormsubmitpayload,
} from "data/payload";
import Sonicwebform from "app/components/mvp/sonicwebform";
import { uiSchema } from "app/pages/studentapplication/model/uiSchema";
import styled from "styled-components";
import Button from "app/components/atoms/Button/RoundCornerButton";
import { break_addressbar } from "utilities/splitUrl";
import CreateOrder from "brand/components/order";
import CustomCheckBox from "app/components/atoms/customCheckBox/CustomCheckBox.mui";
import { customValidate } from "./model/validations";
import { useSelector } from "react-redux";
import { checkOpenApp } from "utilities/checkOpenApp";
import { CAPS_LOCK_WARNING } from "constants/settings";

const StartPage = styled.section`
  h1 {
    text-transform: uppercase;
  }
  ${globalTheme.breakpoints.up("sm")} {
    padding: 4rem 4rem 4rem 150px;
  }
  ${globalTheme.breakpoints.down("xs")} {
    padding: 1rem;
  }
`;

function Student(props) {
  const [isStarted, setStartApplication] = useState(0);
  const [isNew, setisNew] = useState(true);
  const [acceptCondition, setAcceptCondition] = useState(false);
  const [urlParam, seturlParam] = useState({
    formName: "studentApplication",
    subId: "",
  });
  const options = {
    formTitle: "Student Application",
    getFormschemaURL: config.sonicwebform.getFormschema,
    createFormsubmitURL: config.sonicwebform.createFormsubmit,
    getFormsubmitURL: config.sonicwebform.getFormsubmit,
    getFormschemapayload: getFormschemapayload,
    createFormsubmitpayload: createFormsubmitpayload,
    getFormsubmitpayload: getFormsubmitpayload,
    WebFormName: urlParam.formName,
    uiSchema: uiSchema,
    submissionId: urlParam.subId,
    stepCount: 0,
    formschema: {},
    swfdata: {},
    swfId: "",
    createForm: isNew,
    unAuthenticate: false,
    handleChange: props.handleChange,
    emptyOrder: false,
    hasPayment: false,
    validate: customValidate,
    defaultSectionAdditionalDesc: CAPS_LOCK_WARNING,
  };
  const getcontactId = useSelector((state) => state.contactid);
  const [isOpen, setOpenApplication] = useState(0);

  const startApp = () => {
    setStartApplication(1);
  };
  useEffect(() => {
    const fetchDetail = async () => {
      const isCheck = await checkOpenApp("", getcontactId);
      setOpenApplication(isCheck);
    };
    localStorage.setItem("oid", "");
    //console.log("onload " + window.location.href.indexOf("?"));
    if (window.location.href.indexOf("?") > -1) {
      seturlParam(break_addressbar(window.location.href));
      //console.log(break_addressbar(window.location.href));
      setisNew(false);
      setOpenApplication(2);
    } else {
      setisNew(true);
      fetchDetail().catch(console.log);
    }
  }, []);

  useEffect(() => {
    //console.log("url parameters"+JSON.stringify(urlParam))
  }, [urlParam]);

  const onChangeCheckBoxState = (value) => {
    setAcceptCondition(value);
  };

  return (
    <ThemeProvider theme={globalTheme}>
      <AuthenticatedTemplate>
        <div id="cTTP_sonicForm">
          <Grid container spacing={0}>
            <Grid item xs={12} md={12}>
              {/* <Sonicwebform options={options} /> */}
              {isOpen == 2 && (
                <div>
                  {isStarted == 0 ? (
                    <StartPage>
                      <h1>About the application</h1>
                      <br />

                      <h3>
                        PLEASE READ THE FOLLOWING CAREFULLY BEFORE COMPLETING
                        THIS APPLICATION FOR MEMBERSHIP:
                      </h3>
                      <p>A Student Member is a person who:</p>
                      <ul>
                        <li>
                          At the time of admission has a valid registration as a
                          full time student at a tertiary educational
                          institution recognized for this purpose by Council,
                          with the intention of obtaining an academic
                          qualification in civil engineering recognized for this
                          purpose by Council; or
                        </li>
                        <li>
                          Undergoes a regular course of training recognized for
                          this purpose by Council
                        </li>
                      </ul>
                      <br />
                      <br />

                      <h3>NOTES:</h3>
                      <ul>
                        <li>
                          A copy of your University proof of registration needs
                          to be submitted with your application as it is
                          required as proof that you are registered as a full
                          time student.
                        </li>
                        <li>
                          A copy of your ID/Passport needs to be submitted with
                          your application
                        </li>
                        <li>
                          Enjoy free membership for the duration of your proven
                          studies as a full time student.
                        </li>
                        <li>
                          When student members have obtained a degree, diploma
                          or other qualification in Engineering, recognized for
                          the purpose by the Council, they should apply to
                          transfer to the grade of Associate member.
                        </li>
                        <li>
                          A person may not remain a student member after
                          graduating.
                        </li>
                        <li>
                          You remain a member of SAICE until you give written
                          notice of your resignation.
                        </li>
                      </ul>
                      <br />

                      <CustomCheckBox
                        getProps={{
                          id: "acceptCondition",
                          label:
                            "I have read and understand the conditions mentioned above",
                          value: acceptCondition,
                          onChange: onChangeCheckBoxState,
                          schema: { requiredCheck: false },
                        }}
                      />

                      <br />

                      <br />

                      <Button
                        color="primary"
                        variant="contained"
                        disabled={!acceptCondition}
                        onClick={startApp}
                      >
                        Start Application
                      </Button>
                    </StartPage>
                  ) : (
                    <div>
                      <Sonicwebform options={options} />
                    </div>
                  )}
                </div>
              )}
              {isOpen == 1 && (
                <StartPage>
                  <h3>
                    Please go to{" "}
                    <a href="/applications">Manage Existing Applications</a> and
                    continue with your existing application.
                  </h3>
                </StartPage>
              )}
            </Grid>
          </Grid>
        </div>
      </AuthenticatedTemplate>
    </ThemeProvider>
  );
}

export default CreateOrder(Student);
